// src/hooks/useMenus.js
import { useState, useCallback } from "react";
import { menuApi } from "../api/menuApi";

export function useMenus() {
  const [menus,   setMenus]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  const clearError = () => setError(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await menuApi.getAll();
      setMenus(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (payload) => {
    const created = await menuApi.create(payload);
    setMenus(prev => [...prev, created]);
    return created;
  }, []);

  const update = useCallback(async (id, payload) => {
    const updated = await menuApi.update(id, payload);
    setMenus(prev => prev.map(m => m.MENU_ID === id ? updated : m));
    return updated;
  }, []);

  const remove = useCallback(async (id) => {
    await menuApi.delete(id);
    setMenus(prev => {
      const toRemove = getDescendantIds(prev, id);
      return prev.filter(m => !toRemove.has(m.MENU_ID));
    });
  }, []);

  return { menus, loading, error, clearError, fetchAll, create, update, remove };
}

function getDescendantIds(menus, rootId) {
  const ids = new Set([rootId]);
  let changed = true;
  while (changed) {
    changed = false;
    for (const m of menus) {
      if (!ids.has(m.MENU_ID) && ids.has(m.MENU_PARENT_ID)) {
        ids.add(m.MENU_ID);
        changed = true;
      }
    }
  }
  return ids;
}
